import React, { useEffect } from 'react';
import { Form } from 'antd';
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { Popup, TextArea } from '_atoms';
import { Typography } from '_atoms/Typography';
import './style.scss';

interface PopupCancelInterviewUserData {
  first_name_latin?: string;
  last_name_latin?: string;
  first_name_local?: string;
  last_name_local?: string;
  specialities?: Array<{ level?: string; speciality?: string | null }>;
}

interface PopupCancelInterviewProps {
  open: boolean;
  startDate: string | null;
  endDate: string | null;
  userData: PopupCancelInterviewUserData;
  onClose: () => void;
  onConfirm: (values: { comment: string }) => void;
}

export const PopupCancelInterview: React.FC<PopupCancelInterviewProps> = ({
  open,
  startDate,
  endDate,
  userData,
  onClose,
  onConfirm,
}) => {
  const { t } = useTranslation();
  const [form] = Form.useForm();
  const date = `${moment(startDate).format('ddd MMM DD, YYYY H:mm')} – ${moment(endDate).format('H:mm')}`;

  useEffect(() => {
    form.resetFields();
  }, [open]);

  return (
    <Popup
      className="popup-cancel-interview"
      open={open}
      title={t('translation:popup_cancel_interview.title')}
      cancelButtonProps={{ onClick: onClose, children: t('translation:popup_cancel_interview.button_back_to_job') }}
      okButtonProps={{
        children: t('translation:popup_cancel_interview.button_cancel_interview'),
        form: 'form-cancel-interview',
        htmlType: 'submit',
      }}
    >
      <Form name="form-cancel-interview" form={form} initialValues={{ comment: '' }} onFinish={onConfirm}>
        <div className="user-info">
          <Typography.Text className="user-info__title">{`${userData.first_name_latin} ${userData.last_name_latin}`}</Typography.Text>
          <Typography.Caption className="user-info__subtitle">{`${userData.first_name_local} ${userData.last_name_local}`}</Typography.Caption>
          <Typography.Caption className="user-info__subtitle">
            {userData.specialities?.[0]?.level} {userData.specialities?.[0]?.speciality}
          </Typography.Caption>
        </div>
        <div className="info-block">
          <Typography.Label>{t('translation:popup_cancel_interview.label_date_and_time')}</Typography.Label>
          <Typography.Text>{date}</Typography.Text>
        </div>
        <Typography.Text className="popup-cancel-interview__info-text">
          {t('translation:popup_cancel_interview.text_confirm_cancel')}
        </Typography.Text>
        <TextArea
          label={t('translation:popup_cancel_interview.label_comment')}
          placeholder={t('translation:popup_cancel_interview.placeholder_comment')}
          maxLength={6000}
          itemProps={{ name: 'comment' }}
          optional
        />
      </Form>
    </Popup>
  );
};
